import { render, staticRenderFns } from "./newmsg.vue?vue&type=template&id=5d1fae44&scoped=true"
import script from "./newmsg.vue?vue&type=script&lang=js"
export * from "./newmsg.vue?vue&type=script&lang=js"
import style0 from "./newmsg.vue?vue&type=style&index=0&id=5d1fae44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1fae44",
  null
  
)

export default component.exports